import { useTranslation } from 'react-i18next';

import { Landing } from '../components/Landing';

import type { NextPage } from 'next';

const Home: NextPage = () => {
  const { t } = useTranslation();

  return <Landing />;
};

export default Home;
